import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class NavStateService implements OnDestroy {
  public sideNavExpanded = new Subject<boolean>();

  constructor() {}

  sideNavExpandState(expanded: boolean) {
    this.sideNavExpanded.next(expanded);
  }

  ngOnDestroy() {
    this.sideNavExpanded.next();
  }
}
